/**
 * Ruta de la ficha de un producto.
 *
 * Se usa el slug (/producto/exploding-kittens-edicion-original) porque una URL
 * con el nombre del juego dice de qué va la página tanto a quien la comparte
 * por WhatsApp como a Google.
 *
 * El respaldo al id no es defensivo por costumbre: un producto que el ETL
 * acaba de insertar llega con slug null hasta que services.EnsureSlugs pasa por
 * él (al arrancar el API y cada vez que se regenera el sitemap, como mucho 15
 * minutos). Durante esa ventana el enlace por id sigue funcionando, y el
 * backend redirige con 301 al slug en cuanto existe.
 *
 * @param {{slug?: string|null, id?: number|string}} producto
 * @returns {string}
 */
export function rutaProducto(producto) {
  if (!producto) return '/productos';
  return `/producto/${producto.slug || producto.id}`;
}

export default rutaProducto;
